
import PrimaryButton from "./buttons/PrimaryButton";

interface Props {
  onReload: () => void;
}



const UpdateFrontendButton: React.FC<Props> = ({ onReload }) => (
  <div
    style={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 9999,
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      borderRadius: 16,
      background: "#fff",
      padding: "24px 28px 20px 28px",
      minWidth: 270,
      maxWidth: 320,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 12,
    }}
  >
    <div
      style={{
        color: "#1e293b",
        fontWeight: 700,
        fontSize: 16,
        marginBottom: 6,
        textAlign: "center",
        lineHeight: 1.4,
        letterSpacing: 0.1,
      }}
    >
      Új verzió érhető el!<br />Kérjük frissítsd a felületet
    </div>
    <PrimaryButton variant="strike" onClick={onReload}>
      Frissítés
    </PrimaryButton>
  </div>
);

export default UpdateFrontendButton;